interface WelcomeBannerProps {
  firstName?: string;
  subtitle?:  string;
}

const MONTHS = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
const DAYS   = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];

/**
 * Welcome banner pixel-perfect CTO-FRONT-002.
 * Référence : design-dashboard-finance-v1.html lignes 656-665.
 */
export const WelcomeBanner = ({ firstName, subtitle }: WelcomeBannerProps) => {
  const now = new Date();
  const day  = now.getDate();
  const dayName = DAYS[now.getDay()];
  const monthYear = `${MONTHS[now.getMonth()]} ${now.getFullYear()}`;
  const monthYearCapitalized = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);

  return (
    <div className="ds-welcome">
      <div className="ds-welcome-text">
        <div className="ds-welcome-title">
          Bonjour{firstName ? `, ${firstName}` : ''} 👋
        </div>
        <div className="ds-welcome-sub">{subtitle}</div>
      </div>
      <div className="ds-welcome-date">
        <div className="ds-welcome-date-day">{String(day).padStart(2, '0')}</div>
        <div className="ds-welcome-date-rest">
          {monthYearCapitalized}<br />{dayName.charAt(0).toUpperCase() + dayName.slice(1)}
        </div>
      </div>
    </div>
  );
};
